import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "内容分类",
    links: [
      { label: "电影", to: "/category/movie" },
      { label: "电视剧", to: "/category/tv" },
      { label: "综艺", to: "/category/variety" },
      { label: "娱乐资讯", to: "/news" },
    ],
  },
  {
    title: "精选专题",
    links: [
      { label: "华语科幻新浪潮", to: "/topic/topic1" },
      { label: "年度高分剧集精选", to: "/topic/topic2" },
      { label: "治愈系综艺合集", to: "/topic/topic3" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-gradient-to-b from-background-100 to-primary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer mb-4 w-fit">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-sm font-black">
                p18
              </span>
              <span className="text-xl font-black tracking-tight text-foreground-950">
                po<span className="text-primary-500">18</span>
              </span>
            </Link>
            <h2 className="text-base font-semibold text-foreground-900 mb-2">
              po18 娱乐内容聚合平台
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600 max-w-md">
              po18 致力于为大众提供最新最全的娱乐资讯与影视推荐，涵盖电影、电视剧、综艺节目。我们用清晰的分类、真实的资料与用心的推荐，帮你轻松发现值得一看的好内容。
            </p>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-bold text-foreground-900 mb-4">
                {group.title}
              </h3>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-foreground-500">
            © {new Date().getFullYear()} po18 娱乐内容聚合平台 · 本站内容为演示数据，仅供展示
          </p>
          <p className="text-xs md:text-sm text-foreground-500">
            本站不提供在线播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}